import React from 'react'
import Party from '../../models/Party'
import { IPartyNumberMap } from '../../models/TypeHelper'
import Utilities from '../../utils/Utilities'
import './PollSliderAnnotations.scss'

interface IProps {
  polls: IPartyNumberMap
}

class PollSliderAnnotations extends React.Component<IProps> {
  protected sliderAnnotationsRef: React.RefObject<HTMLDivElement>

  public constructor(props: IProps) {
    super(props)

    this.sliderAnnotationsRef = React.createRef()
  }

  public render(): JSX.Element {
    const partyKeys = Object.keys(this.props.polls)
    const width = this.sliderAnnotationsRef.current
      ? this.sliderAnnotationsRef.current.getBoundingClientRect().width
      : 0

    const sliderAnnotations = partyKeys.map(
      (partyKey): JSX.Element => {
        const pollValue = this.props.polls[partyKey]
        const lowWidth = width < 800
        const widthValue = lowWidth
          ? `calc(100% / ${partyKeys.length})`
          : `calc(${pollValue * 100}% + 50px)`
        return (
          <div
            className="PollSliderAnnotation"
            key={partyKey}
            style={{
              width: widthValue,
              color: Party.fromKey(partyKey).rgbColor
            }}
          >
            <div className="PartyKey">{partyKey} </div>
            <div className="PartyVotePercent">
              <strong>
                {Utilities.formatPercent(this.props.polls[partyKey])}
              </strong>
            </div>
          </div>
        )
      }
    )

    return (
      <div
        id="slider-annotations"
        className="col-12"
        ref={this.sliderAnnotationsRef}
      >
        {sliderAnnotations}
      </div>
    )
  }
}

export default PollSliderAnnotations
